import { render, staticRenderFns } from "./NotDel.vue?vue&type=template&id=56686c35&scoped=true&"
import script from "./NotDel.vue?vue&type=script&lang=js&"
export * from "./NotDel.vue?vue&type=script&lang=js&"
import style0 from "./NotDel.vue?vue&type=style&index=0&id=56686c35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56686c35",
  null
  
)

export default component.exports